import {FanzineSportsActionTypes} from "../constants/FanzineSports";


export const setIsLogin = (data) => {
	return {
		type: FanzineSportsActionTypes.SET_IS_LOGIN,
		payload: data,
	}
}
